/**
  @module @ember-data/store
*/

var IDENTIFIERS = new WeakMap();
export default function isStableIdentifier(identifier) {
  return IDENTIFIERS.has(identifier);
}
export function markStableIdentifier(identifier) {
  IDENTIFIERS.set(identifier, 'is-identifier');
}
export function unmarkStableIdentifier(identifier) {
  IDENTIFIERS.delete(identifier);
}